import { useGetPageField } from './useGetPageField';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable to get border styling from the theme
 *
 * This retrieves the border color value from the theme's OTHER_COLORS section.
 * Returns an object that can be extended with additional border properties in the future
 * (e.g., borderWidth, borderStyle, borderRadius).
 *
 * Usage in component:
 * ```ts
 * const { borderColor } = useFieldBorder();
 *
 * // In template or computed style:
 * const style = computed(() => ({
 *   border: borderColor.value ? `1px solid ${borderColor.value}` : undefined
 * }));
 * ```
 *
 * @returns Object containing border-related computed refs
 */
export const useFieldBorder = () => {
  const borderColor = useGetPageField({
    registryId: PUI.REGISTRY_IDS.DEFAULT_THEME,
    blockKey: PUI.THEME_BLOCK_KEYS.COLORS,
    sectionKey: PUI.THEME_SECTION_KEYS.OTHER_COLORS,
    fieldKey: PUI.THEME_FIELD_KEYS.BORDER,
  });

  return {
    borderColor,
  };
};
